package uk.co.nickthecoder.kojak

import kotlin.math.min

interface MPPReader {
    fun close()
    fun read(): Int
    fun read(charArray: CharArray): Int
    fun read(charArray: CharArray, offset: Int, length: Int): Int
}

class MPPStringReader(
    val string: String
) : MPPReader {

    private var index = 0

    override fun close() {}
    override fun read(): Int {
        return string[index ++].code
    }

    override fun read(charArray: CharArray): Int {
        return read(charArray, 0, charArray.size)
    }

    override fun read(charArray: CharArray, offset: Int, length: Int): Int {
        val toCopy = min(length, string.length - index)
        if (toCopy <= 0) return - 1
        string.toCharArray(charArray, offset, index, index + toCopy)
        index += toCopy
        return toCopy
    }
}
